export default __webpack_public_path__ + "static/media/item1.1e503448.png";